export const useHelpers = () => {
    
    const customHelper = () => {
        console.log('HOLA MUNDO')
    }
    
    return Object.freeze({
        customHelper,
    })
}